import { lead } from './lead';
import type { Brand } from './types';

export const stellencockpit: Brand = {
  ...lead,
  key: 'stellencockpit',
  // placeholder links until the legal page URLs are known
  legalLinks: { imprint: '#', privacy: '#', terms: '#' },
};
